import { Company } from '../../shared/types/company';

export type GetAllCompaniesResponse = {
  companies: Company[];
};

export type GetCompanyByIdResponse = {
  company: Company;
};

export type CompanyStats = {
  companyId: string;
  companyName: string;
  filesUploaded: number;
  storageUsedBytes: number;
  storageCapacityMegabytes: number;
  signedAgreements: number;
  registeredAgreements: number;
  projects: number;
  adminUsers: number;
  employeeUsers: number;
  userSessionsInPeriod: number;
  /** @deprecated alias of `userSessionsInPeriod`; will be dropped in a follow-up release. */
  loginsLast30Days: number;
};

export type GetCompaniesStatsResponse = {
  currentLimit: number;
  currentOffset: number;
  totalEntities: number;
  stats: CompanyStats[];
  fromDate?: string;
  toDate?: string;
  /** @deprecated echoed alongside the new `fromDate`/`toDate`; will be dropped in a follow-up release. */
  periodDays?: number;
};

export type GetCompanyStatsResponse = {
  stats: CompanyStats;
};

export type TimeSeriesGranularity = 'day' | 'week' | 'month';

export type TimeSeriesBucket = {
  bucketStart: string;
  bucketEnd: string;
};

export const TIME_SERIES_METRICS = [
  'signedAgreements',
  'registeredAgreements',
  'projects',
  'userSessions',
  'filesUploaded',
  'storageUsedBytes',
  'adminUsers',
  'employeeUsers',
  'storageCapacityMegabytes',
] as const;

export type TimeSeriesMetric = typeof TIME_SERIES_METRICS[number];

export const TIME_SERIES_CURRENT_ONLY: TimeSeriesMetric[] = [
  'adminUsers',
  'employeeUsers',
  'storageCapacityMegabytes',
];

export type CompanyTimeSeriesResponse = {
  companyId: string;
  fromDate: string;
  toDate: string;
  effectiveFromDate: string;
  effectiveToDate: string;
  granularity: TimeSeriesGranularity;
  buckets: TimeSeriesBucket[];
  series: Record<string, number[]>;
  currentValues: {
    adminUsers: number;
    employeeUsers: number;
    storageCapacityMegabytes: number;
  };
  currentOnlyMetrics: string[];
};

export type UpdateCompanyRequest = Pick<
  Company,
  | 'name'
  | 'organizationalNumber'
  | 'address'
  | 'postalCode'
  | 'city'
  | 'country'
  | 'phoneNumber'
  | 'website'
>;
